/* Sections.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { AppTile, AppTilesGridContainer } from '@atlassian/mpac-app-tile';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { breakpointValues, mapResponsiveBreakpointToScreenSize, PartialOutageError, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { MarketplaceStoreHomePageHighlightedSectionVariation } from '@atlassian/mpac-types/graphql-gateway-types';
import { useEnvironment, useSource } from '@atlassian/mpac-utils';
import React from 'react';
import { SectionWrapper } from '../../HomepageCommon.styles';
import { useHomepageAnalytics } from '../../hooks/useHomepageAnalytics';
import { SECTIONS } from '../../hooks/useHomepageAnalytics/constants';
import { EnterpriseAppsSectionSkeleton } from '../EnterpriseAppsSection';
import { ProminentSection, ProminentSectionInfo } from '../ProminentSection';
import { RegularSection } from '../RegularSection';
import { SectionsSkeleton } from './Skeleton';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _9 = "@media (min-width:64rem) and (max-width:89.99rem){._1acz1gtx{padding:var(--_1bm102r)}}";
const _8 = "@media (min-width:48rem) and (max-width:63.99rem){._13zn1gtx{padding:var(--_1bm102r)}}";
const _7 = "@media not all and (min-width:48rem){._15txwcbu{padding:var(--_4thsry)}}";
const _6 = "._1wpz1fhb{align-self:stretch}";
const _5 = "._2lx21bp4{flex-direction:column}";
const _4 = "._1e0c1txw{display:flex}";
const _3 = "._kqswh2mm{position:relative}";
const _2 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _ = "._1yt4ojjz{padding:var(--_8gy4v2)}";
const SectionWrapperStyle = null;

// eslint-disable-next-line max-lines-per-function
export function Sections(_ref) {
  let {
    isLoading,
    isError,
    data,
    productId
  } = _ref;
  const source = useSource();
  const environment = useEnvironment();
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  const isTablet = breakpoint < breakpointValues.md && breakpoint >= breakpointValues.sm;
  const {
    enableMpacWebCoherence
  } = useStatsig();
  const {
    trackTileClick,
    trackHomeScreenErrorState
  } = useHomepageAnalytics();
  if (isLoading) {
    const tileCount = isMobile ? 3 : isTablet ? 4 : 6;
    return /*#__PURE__*/_jsx(UFOLoadHold, {
      name: SECTIONS.LISTING,
      children: productId ? /*#__PURE__*/_jsx(EnterpriseAppsSectionSkeleton, {
        tileCount: tileCount
      }) : /*#__PURE__*/_jsx(SectionsSkeleton, {})
    });
  }
  if (isError) {
    trackHomeScreenErrorState(SECTIONS.LISTING);
    return /*#__PURE__*/_jsx(SectionWrapper, {
      children: /*#__PURE__*/_jsx(PartialOutageError, {})
    });
  }
  const tileClickHandler = (app, title, index, hideDescription) => {
    const tileClickEventData = {
      app,
      sectionTitle: title,
      index,
      hideDescription
    };
    trackTileClick(tileClickEventData);
  };
  if (data) {
    // eslint-disable-next-line max-lines-per-function
    const sections = data.map(section => {
      const {
        id,
        title,
        description,
        apps,
        screenSpecificProperties,
        __typename,
        navigationUrl
      } = section;
      const sectionId = id === null || id === void 0 ? void 0 : id.split('__')[0];
      const breakpointId = mapResponsiveBreakpointToScreenSize(breakpoint, Object.keys(screenSpecificProperties));
      const {
        appsCount,
        hideDescription
      } = screenSpecificProperties[breakpointId];
      const appsToRender = apps.slice(0, appsCount);
      if (__typename === 'MarketplaceStoreHomePageHighlightedSection' && section.highlightVariation === MarketplaceStoreHomePageHighlightedSectionVariation.Prominent) {
        if (enableMpacWebCoherence()) {
          return /*#__PURE__*/_jsx(ProminentSection, {
            "data-testid": "section_".concat(sectionId),
            children: /*#__PURE__*/_jsxs(AppTilesGridContainer, {
              children: [/*#__PURE__*/_jsx(ProminentSectionInfo, {
                title: title,
                description: description,
                navigationUrl: navigationUrl
              }), appsToRender.map((app, index) => /*#__PURE__*/_jsx(AppTile, {
                tileData: app,
                environment: environment,
                source: source,
                hideTagline: hideDescription,
                onTileClick: () => tileClickHandler(app, title, index, hideDescription)
              }, app.addonKey))]
            })
          }, sectionId);
        }
        return /*#__PURE__*/_jsx(SectionWrapper, {
          "data-testid": "section_".concat(sectionId),
          children: /*#__PURE__*/_jsx(ProminentSection, {
            children: /*#__PURE__*/_jsxs(AppTilesGridContainer, {
              children: [/*#__PURE__*/_jsx(ProminentSectionInfo, {
                title: title,
                description: description,
                navigationUrl: navigationUrl
              }), appsToRender.map((app, index) => /*#__PURE__*/_jsx(AppTile, {
                tileData: app,
                environment: environment,
                source: source,
                hideTagline: hideDescription,
                onTileClick: () => tileClickHandler(app, title, index, hideDescription)
              }, app.addonKey))]
            })
          })
        }, sectionId);
      } else {
        if (enableMpacWebCoherence()) {
          return /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_, _2, _3, _4, _5, _6, _7, _8, _9]
            }), /*#__PURE__*/_jsx("div", {
              "data-testid": "section_".concat(sectionId),
              className: ax(["_1yt4ojjz _zulpxy5q _kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1fhb _15txwcbu _13zn1gtx _1acz1gtx"]),
              style: {
                "--_8gy4v2": ix("var(--ds-space-800, 64px)".concat(" 0")),
                "--_1bm102r": ix("var(--ds-space-500, 40px)".concat(" 0")),
                "--_4thsry": ix("var(--ds-space-300, 24px)".concat(" 0"))
              },
              children: /*#__PURE__*/_jsx(RegularSection, {
                title: title,
                description: description,
                navigationUrl: navigationUrl,
                children: /*#__PURE__*/_jsx(AppTilesGridContainer, {
                  children: appsToRender.map((app, index) => /*#__PURE__*/_jsx(AppTile, {
                    tileData: app,
                    environment: environment,
                    source: source,
                    hideTagline: hideDescription,
                    onTileClick: () => tileClickHandler(app, title, index, hideDescription)
                  }, app.addonKey))
                })
              })
            }, sectionId)]
          }, sectionId);
        }
        return /*#__PURE__*/_jsx(SectionWrapper, {
          "data-testid": "section_".concat(sectionId),
          children: /*#__PURE__*/_jsx(RegularSection, {
            title: title,
            description: description,
            navigationUrl: navigationUrl,
            children: /*#__PURE__*/_jsx(AppTilesGridContainer, {
              children: appsToRender.map((app, index) => /*#__PURE__*/_jsx(AppTile, {
                tileData: app,
                environment: environment,
                source: source,
                hideTagline: hideDescription,
                onTileClick: () => tileClickHandler(app, title, index, hideDescription)
              }, app.addonKey))
            })
          })
        }, sectionId);
      }
    });
    return /*#__PURE__*/_jsx(_Fragment, {
      children: sections
    });
  } else {
    return null;
  }
}